import * as Style from "../style/StyledComponents";
import Navbar from "./Navbar";
import {Mint} from "./Mint";
import { abbreviateAddress, chain, links } from "./Config";

import imgHero from "../images/gems.png";

function SectionHero() {
	return (
         <Style.Section>
      		<Style.HeroContainer >	

      			<Style.ColumnHeroImage>
				  <Style.ShowMobile><br/><br/></Style.ShowMobile>
      				<div style={{margin:"0 auto"}}>
      			    <Style.ResponsiveImage src={imgHero} />
      			    </div>
      			</Style.ColumnHeroImage>
				

      			<Style.ColumnHeroDesc>
				  <Style.ShowMobile><br/></Style.ShowMobile>
      			   <h1>Gems</h1>
               <p style={{fontSize:"0.8em"}}>by <a href={links.twitter} target="_blank">@dailofrog</a></p>
      			   <br/>
      				<p>100% fully onchain gems of opulence on <a href={links.hyperliquid} target="_blank">Hyperliquid EVM</a>. No utility, no roadmap, just oooh shiny rocks ✨</p>

              <br/>

			  <Style.ShowMobile><br/></Style.ShowMobile>
              <Mint/>
      				
              <br/>
			  <Style.ShowMobile><br/></Style.ShowMobile>
      				<Style.HiddenMobile><div style={{borderBottom:"1px solid white", fontFamily:"Header", padding:"0.25em 0", marginBottom:"0.0em"}}>Collection Info</div></Style.HiddenMobile>
              <hr/>
      				<p style={{fontSize:"0.6em", textAlign:"left"}}>
					  ▪ Secondary Market: <a href={links.driptrade} target="_blank">drip.trade</a> or <a href={links.net} target="_blank">Net</a><br/>
					  ▪ Thesis: <a href={`https://x.com/ZEEEPIO/status/1897405036625580535`} target="_blank">"The rocks are shiny."</a><br/>
          ▪ Pixel Art: <a href={links.twitterGoop} target="_blank">@goopgoop_art</a><br/>
					
					
          ▪ Total Supply: 1,111 Gems<br/>
					{/*▪ Mint Price (each): 1 $HYPE<br/>*/}
          ▪ Token Type: ERC-721 (100% onchain)<br/>
      		▪ Network: <a href={links.hyperliquid} target="_blank">{chain.name}</a><br/>
					▪ Contract: <a href={links.contractFrontEnd} target="_blank">{abbreviateAddress(process.env.REACT_APP_CONTRACT_FRONTEND,5)}</a><br/>
					▪ Deployment Date: <a href={"https://hyperliquid.cloud.blockscout.com/tx/0xd71b19002f9cf3c5c8dbfe014f541d42adbf9c79b0f8ec59fd3d5a5b22d973e9"} target="_blank">March 4, 2025</a><br/>
					▪ Sales Tracker Bot: <a href={"https://x.com/GemsTracker"} target="_blank">@GemsTracker</a><br/>
					{/*▪ Whitelist: <a href="https://linktr.ee/dailofrog" target="_blank">dailofrog collection</a> holders, <a href="https://x.com/tinyhypercats" target="_blank">tiny hyper cats</a><br/>*/}
          {/*▪ Marketplace: <a href={links.opensea} target="_blank">Net</a>*/}
					</p>

					<Style.ShowMobile><br/><br/></Style.ShowMobile>
      			</Style.ColumnHeroDesc>
      		</Style.HeroContainer>
       
         </Style.Section>)
}

function FrontPage() {
  return (
      <>
        <SectionHero/>
      </>
  );
}

export default FrontPage;
